import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

type TaskNameColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
};

export const taskNameColumnConfig = <T extends TableRow>({
  options,
}: TaskNameColumnConfig<T> = {}): TableColumn<T> => ({
  id: 'name',
  label: <Trans i18nKey="task_name" />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis">{value}</div>
  ),
  acessorKey: 'name',
  sortable: true,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
